import {Alert} from "react-bootstrap";
import React from "react";

export const AlertRoom = () => {
    return (
        <Alert variant="info">
            Ze względu na bezpieczeństwo przeciwpożarowe zabronione jest używanie w pokojach grzałek, żelazek i innych podobnych urządzeń elektrycznych nie stanowiących stałego wyposażenia tych pomieszczeń. Niedozwolone jest również używanie ognia otwartego.
        </Alert>
    );
};